export default __webpack_public_path__ + "static/Visiomate_EcoZohm_Case_Study-11134ae87c411ac10176ed944b7174de.pdf";